module.exports = __webpack_public_path__ + "static/media/project16.f2922875.jpg";